/**
 * @file 新闻详情页Store
 * @author FengGuang(fengguang01@baidu.com)
 */
import {useEffect, useState} from 'react';
import immer from 'immer';

import {
    fetchGetNewsDetail
} from '../../api/pages/newsApi';

import {INewsDetail, INewsItem} from './type';

// 预请求
let preRequest: any = {};
if (window) {
    const serverRenderData = (window as any).serverRenderData;
    if (serverRenderData) {
        preRequest.fetchGetNewsDetail = Promise.resolve({body: serverRenderData});
    }
    else {
        preRequest.fetchGetNewsDetail = fetchGetNewsDetail(window.location.search.slice(1));
    }
}


const useNewsDetailStore = () => {
    const [newsDetail, setNewsDetail] = useState<INewsDetail>({
        id: 0,
        title: '',
        content: '',
        pubTime: '',
        pv: 0,
        preNews: undefined,
        nextNews: undefined,
        relations: [],
    });

    useEffect(() => {
        const getNewsList = async (): Promise<void> => {
            const fetchFunc = preRequest.fetchGetNewsDetail || fetchGetNewsDetail(window.location.search.slice(1));
            delete preRequest.fetchGetNewsDetail;

            let res;
            try {
                res = await fetchFunc;
            }
            catch (err: any) {
                // ignore
            }
            if (res) {
                const theResult = res.body.result || {};
                setNewsDetail(prevState =>
                    immer(prevState, draft => {
                        draft.id = theResult.id;
                        draft.title = theResult.title;
                        draft.pv = theResult.pv;
                        draft.pubTime = theResult.pubTime;
                        draft.content = theResult.content;

                        const preNews = theResult.preNews;
                        if (preNews) {
                            draft.preNews = {
                                id: preNews.id,
                                title: preNews.title,
                                link: preNews.link,
                                pv: preNews.pv
                            };
                        }

                        const nextNews = theResult.nextNews;
                        if (nextNews) {
                            draft.nextNews = {
                                id: nextNews.id,
                                title: nextNews.title,
                                link: nextNews.link,
                                pv: nextNews.pv
                            };
                        }

                        const relations: INewsItem[] = theResult.relations || [];
                        draft.relations = relations.map(item => ({
                            id: item.id,
                            title: item.title,
                            link: item.link,
                            pv: item.pv
                        }));
                    })
                );
            }
        };

        getNewsList();
    }, []);

    return newsDetail;
};

export default useNewsDetailStore;
